/* import __COLOCATED_TEMPLATE__ from './entries-table-teams.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import dayjs from 'dayjs';

export default class EntriesTableTeamsComponent extends Component
{
	@service store;
	@service errorManager;
	
	@tracked isAddingNewTeam = false;
	@tracked newTeamName = "";
	@tracked newTeamBib = "";
	
	@action
	async statusSelectionChanged(team,browserEvent)
	{
		team.status = browserEvent.target.value;

		try
		{
			await team.save();
		}
		catch (error)
		{
			team.rollbackAttributes();
			// Error is displayed by the adapter
		}
	}
	
	@action
	async saveNewTeam()
	{
		var store = this.store;

		const newTeam = store.createRecord('Team',
		{
			name:this.newTeamName,
			bib:this.newTeamBib,
			EventId: this.args.event,
		});
		try
		{
			await newTeam.save();
			store.findRecord('Team',newTeam.id);
		}
		catch (error)
		{
			// Error is displayed by the adapter
			newTeam.rollbackAttributes();
			return;
		}

		this.isAddingNewTeam = false;
		this.newTeamName = "";
		this.newTeamBib = "";
	}
	
	@action
	cancelNewTeam()
	{
		this.isAddingNewTeam = false;
		this.newTeamName = "";
		this.newTeamBib = "";
	}
	
	@action
	async deleteTeam(team)
	{
		const entries = await team.get('entries')

		if(entries.length == 0)
		{
			team.deleteRecord();
			try
			{
				team.save();
			}
			catch (error)
			{
				// Error is displayed by the adapter
				team.rollbackAttributes();
			}
		}
		else
		{
			this.errorManager.addError("Team has entries. Remove entries before deleting team.", { clearable: true, type: 'validation' });
		}
	}
	
	@action
	toggleDetails(team)
	{
		var currentVal = team.showDetails;
		team.set('showDetails',!currentVal);
	}
}